import { QuestionCircleOutlined, SortDescendingOutlined, SortAscendingOutlined,} from '@ant-design/icons';
import React, { Fragment, useState, useEffect } from 'react';
import { useUserList, useDeleteUser, useStatusUser } from "hooks/user/user";
import { PAGES, ACTIONS, usePermissions } from 'hooks/permissions/permissions';
import StatusBadge from 'components/statusBadge';
import { Row, Col, Button, Input, Pagination, Popconfirm, message } from 'antd';
import { statusColor, PAGE_SIZE_OPTIONS, DEFAULT_PAGE_SIZE } from "helpers/commonFunctions";
import { Link } from 'react-router-dom';
import Image from 'helpers/Image';
import "../style.css";
import TableStateRow from "components/tableState";

const Admin = () => {

    const { can } = usePermissions();
    const canAdd = can(PAGES.USER, ACTIONS.ADD);
    const canEdit = can(PAGES.USER, ACTIONS.EDIT);
    const canDelete = can(PAGES.USER, ACTIONS.DELETE);
    const canViewRoles = can(PAGES.ROLES, ACTIONS.VIEW);
    const showActions = canEdit || canDelete;
    const columnCount = showActions ? 7 : 6;

    const [page, setPage] = useState(DEFAULT_PAGE_SIZE);
    const [listData, setListData] = useState(null);
    const [pageNumber, setPageNumber] = useState(0);
    const [searchKey, setSearchKey] = useState("");
    const [defaultCall, setDefaultCall] = useState(false);
    const [sortField, setSortField] = useState("");
    const [sortMethod, setSortMethod] = useState("desc");
    const [initValues, setInitValues] = useState({
        "pageNumber": pageNumber,
        "pageSize": page,
        "searchKey": searchKey
    });
    const [sorting, setSorting] = useState({
        "iu.first_name": null,
        "iu.last_name": null,
        "iu.email": null,
        "iu.internal_user_id": null,
        "iu.active": null,
    });

    const { mutate: getUserList, data: userListData, isLoading: Loading } = useUserList();
    const { mutate: deleteUser, isLoading: deleteLoading } = useDeleteUser();
    const { mutate: statusChange } = useStatusUser();

    const deleteId = (id) => {
        deleteUser(id, {
            onSuccess: (item) => {
                if (item.statusCode === 200) {
                    message.success(item.message);
                    onFetchUserList(initValues);
                }
                else {
                    message.error(item?.message);
                }
            },
        });
    }
    const handleConfirmActive = (id) => {
        statusChange(id, {
            onSuccess: (item) => {
                if (item.statusCode === 200) {
                    message.success(item.message);
                    onFetchUserList(initValues);
                }
                else {
                    message.error(item?.message);
                }
            },
        });
    }

    const onSortChange = async (column) => {
        initValues.pageNumber = 0;
        initValues.sortField = column;
        initValues.sortMethod = sorting[column] === 'asc' ? 'desc' : 'asc';
        setPageNumber(0);
        const newSorting = {
            ...sorting,
            [column]: sorting[column] === 'asc' ? 'desc' : 'asc',
        };
        setSorting(newSorting);
        setInitValues(initValues);
        setSortField(column);
        setSortMethod(newSorting[column]);
        setListData([]);
    };

    const onFetchUserList = (values) => {
        getUserList(values, {
            onSuccess: (item) => {
                setListData(item?.data?.content);
            }
        })
    }

    const onChange = (page) => {
        initValues.pageNumber = page - 1;
        setInitValues(initValues);
        setPageNumber(page - 1);
    }

    const onShowSizeChange = (current, pageSize) => {
        setPage(initValues.pageSize = pageSize)
    }

    const onSearchHandler = (e) => {
        initValues.searchKey = e.target.value;
        let data = { ...initValues };
        data.searchKey = e.target.value;
        data.pageNumber = e.target.value !== "" ? 0 : initValues.pageNumber;
        e.target.value !== "" ? data.pageNumber = 0 : data.pageNumber = pageNumber;
        setInitValues(data);
        setSearchKey(e.target.value);
    }
    useEffect(() => {
        setDefaultCall(true);
    }, [])

    useEffect(() => {
        if (defaultCall) {
            onFetchUserList(initValues);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultCall, pageNumber, searchKey, page,sortField,sortMethod]);


    return (
        <Fragment>
            <div className="common-head">
                <div className="title">
                    <h1>Admin</h1>
                    <p>Manage Admins With Roles & Responsibilities</p>
                </div>
                <div className="txt-right">
                    <Input placeholder='Search' onChange={onSearchHandler} prefix={<Image className="search-img" name={"search.svg"} />} allowClear />

                    {!canViewRoles ? null : <Link to="/admin/roles">
                        <Button className="black">Roles</Button>
                    </Link>}
                    {!canAdd ? null : <Link to="/admin/create">
                        <Button><Image name="plus.png" /> New </Button>
                    </Link>}
                </div>
            </div>
            <div className="common-table">
                <table>
                    <thead>
                        <tr>
                            <th>First name {sorting["iu.first_name"] === 'asc' ? <SortAscendingOutlined onClick={() => onSortChange("iu.first_name")} /> : <SortDescendingOutlined onClick={() => onSortChange("iu.first_name")} />}</th>
                            <th>Last name {sorting["iu.last_name"] === 'asc' ? <SortAscendingOutlined onClick={() => onSortChange("iu.last_name")} /> : <SortDescendingOutlined onClick={() => onSortChange("iu.last_name")} />}</th>
                            <th>User name</th>
                            <th>Email {sorting["iu.email"] === 'asc' ? <SortAscendingOutlined onClick={() => onSortChange("iu.email")} /> : <SortDescendingOutlined onClick={() => onSortChange("iu.email")} />}</th>
                            <th>Designation</th>
                            <th>Status {sorting["iu.active"] === 'asc' ? <SortAscendingOutlined onClick={() => onSortChange("iu.active")} /> : <SortDescendingOutlined onClick={() => onSortChange("iu.active")} />}</th>
                            {showActions ? <th>Action</th> : null}
                        </tr>
                    </thead>
                    <tbody>
                        {Loading ? (
                            <TableStateRow colSpan={columnCount} loading />
                        ) : listData == null || listData === undefined || listData?.length === 0 ? (
                            <TableStateRow colSpan={columnCount}>No users found</TableStateRow>
                        ) : listData.map((item, a) => (
                                <tr key={a}>
                                    <td>{item?.firstName}</td>
                                    <td>{item?.lastName}</td>
                                    <td>{item?.firstName} {item?.lastName}</td>
                                    <td>{item?.email}</td>
                                    <td>{item?.role}</td>
                                    {/* <td><button className={statusColor(item?.status)}>{item?.status ? "Active" : "InActive"}</button></td> */}
                                    <td>
                                        {canEdit ? <Popconfirm title={`Are you sure you want to ${item?.status === true ? "inactivate" : "activate"} this ${item?.firstName} ${item?.lastName}?`}
                                            onConfirm={() => handleConfirmActive(item.internalUserId)}
                                            icon={
                                                <QuestionCircleOutlined />
                                            }
                                            okText="Yes"
                                            cancelText="No">
                                            <button className={statusColor(item.status)}>
                                                {item?.status ? "Active" : "InActive"}
                                            </button>
                                        </Popconfirm> : <StatusBadge active={item?.status} />}
                                    </td>
                                    {showActions ? <td>
                                        {!canEdit ? null : <Link to={`/admin/${item?.internalUserId}`} state={item}>
                                            <Image name="edit.png" />
                                        </Link>}
                                        {!canDelete ? null : <Popconfirm
                                            Loading={deleteLoading}
                                            title={`Are you sure to delete ${item?.firstName} ${item?.lastName}?`}
                                            onConfirm={() => deleteId(item?.internalUserId)}
                                            icon={<QuestionCircleOutlined />}
                                            okText="Yes"
                                            cancelText="No"
                                        >
                                            <Image name="delete.png" />
                                        </Popconfirm>}
                                    </td> : null}
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
            <Row className="table-pagination">
                <Col md={12}>
                    <h5>Showing {pageNumber === 0 ? 1 : (userListData?.data?.pageable?.offset + 1 || 0)} to {page === 0 ? (userListData?.data?.pageable?.offset + listData?.length || 0) : (userListData?.data?.pageable?.offset + userListData?.data?.numberOfElements || 0)} of {userListData?.data?.totalElements} entries</h5>
                </Col>
                <Col md={12} className="txt-right">
                    {userListData?.data?.content?.length === 0 ? null : <Pagination pageSize={page} showSizeChanger pageSizeOptions={PAGE_SIZE_OPTIONS} onChange={onChange} current={pageNumber + 1} onShowSizeChange={onShowSizeChange} total={userListData?.data?.totalElements} />}
                </Col>
            </Row>
        </Fragment>
    )
}

export default Admin;
